/**
 * 塗鴉圖庫目錄：unDraw 全庫（jsDelivr CDN，與 unDraw 官網同數量，CORS 友善，無需後端）。
 */

import undrawSlugs from './undraw-slugs.json';

export interface DoodleEntry {
  readonly id: string;
  readonly name: string;
  /** 搜尋用關鍵字（英文等），逗號或空白分隔 */
  readonly keywords?: string;
  /** SVG 圖片 URL */
  readonly url: string;
}

export interface DoodlePack {
  readonly id: string;
  readonly label: string;
  readonly description: string;
  readonly entries: readonly DoodleEntry[];
}

const UNDRAW_SVG_BASE = 'https://cdn.jsdelivr.net/npm/undraw-svg@1.0.0/svgs';

/** slug 轉顯示名稱（如 success-factors → Success Factors） */
function slugToTitle(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

const UNDRAW_ENTRIES: DoodleEntry[] = (undrawSlugs as string[]).map(slug => ({
  id: `undraw-${slug}`,
  name: slugToTitle(slug),
  keywords: slug.replace(/-/g, ' '),
  url: `${UNDRAW_SVG_BASE}/${slug}.svg`,
}));

export const DOODLE_PACKS: readonly DoodlePack[] = [
  {
    id: 'undraw',
    label: 'unDraw 全庫',
    description: 'unDraw 全插畫庫（與官網同數量，MIT，CORS 友善，可商用）',
    entries: UNDRAW_ENTRIES,
  },
];

/** 供搜尋用：所有塗鴉條目含所屬 pack 標籤 */
export function getAllDoodleEntriesWithPack(): readonly (DoodleEntry & {
  packLabel: string;
})[] {
  return DOODLE_PACKS.flatMap(pack =>
    pack.entries.map(entry => ({ ...entry, packLabel: pack.label }))
  );
}

export function getDoodleEntryByUrl(url: string): DoodleEntry | undefined {
  for (const pack of DOODLE_PACKS) {
    const found = pack.entries.find(e => e.url === url);
    if (found) return found;
  }
  return undefined;
}

/** 回傳要加入畫布的 SVG URL（僅 unDraw 時等同 entry.url） */
export function getResolvedDoodleUrl(
  entry: DoodleEntry,
  _apiBase: string
): string {
  return entry.url;
}

/** 回傳用於 &lt;img src&gt; 的 URL */
export function getDoodleDisplayUrl(
  entry: DoodleEntry,
  _apiBase: string
): string {
  return entry.url;
}
